import { cva } from "class-variance-authority";
import { Icon } from "../icons";
import { getFileIconColor, getFileIconName } from "../utils";

/** Props Interface */
interface FileIconProps {
	fileType: string | undefined;
	fileName?: string | null;
	size?: number | null;
}

const ICON_SIZE = 18;

export function FileIcon({ fileType, fileName, size = ICON_SIZE }: FileIconProps) {
	if (!fileType && !fileName)
		return (
			<Icon
				name="Loader"
				className="stroke-primary-500 animate-spin"
			/>
		);

	const fileIconName = getFileIconName(fileType ?? "", fileName);
	const fileIconColor = getFileIconColor(fileType ?? "", fileName);
	const iconClasses = icon({ color: fileIconColor });

	return (
		<Icon
			size={size}
			name={fileIconName}
			className={iconClasses}
		/>
	);
}

const icon = cva([], {
	variants: {
		color: {
			primary: "stroke-primary-500",
			blue: "stroke-blue-500",
			green: "stroke-green-500",
			purple: "stroke-purple-500",
			red: "stroke-red-500",
			amber: "stroke-amber-500",
			orange: "stroke-orange-500",
			emerald: "stroke-emerald-500",
		},
	},
});
